<template>
  <div class="apply-form">
    <h1 class="form-title">{{ $cms('c_7961979fe6a6', 'f_0001', "立即申请，成为魔筷合作主播") }}</h1>
    <div class="form-desc">
      <h2>{{ $cms('c_7961979fe6a6', 'f_0002', "主播合作申请") }}</h2>
      <p>
        {{ $cms('c_7961979fe6a6', 'f_0003', "如果你目前面临：内容如何提升才能涨粉？") }}<br>
        {{ $cms('c_7961979fe6a6', 'f_0004', "如果你目前面临：直播卖货如何能卖的更多？") }}<br>
        {{ $cms('c_7961979fe6a6', 'f_0005', "如果你目前面临：想要做专场，缺乏团队或品牌支持？") }}<br>
        {{ $cms('c_7961979fe6a6', 'f_0006', "告诉我你的现状，来吧，合作一场，2025年开启新高峰！") }}
      </p>
    </div>
    <div class="form-content">
      <el-form ref="form" :model="form" :rules="rules" :inline="true" label-position="top">
        <div class="row">
          <el-form-item class="form-item" prop="accountId" :label="$cms('c_7961979fe6a6', 'f_0007', &quot;你的账号ID（抖音、快手、视频号等）&quot;)">
            <el-input v-model="form.accountId" :placeholder="$cms('c_7961979fe6a6', 'f_0008', &quot;请输入你的账号ID&quot;)" class="learn"></el-input>
          </el-form-item>

          <el-form-item class="form-item" prop="fansCount" :label="$cms('c_7961979fe6a6', 'f_0009', &quot;你的粉丝数&quot;)">
            <el-input v-model="form.fansCount" :placeholder="$cms('c_7961979fe6a6', 'f_0010', &quot;请输入你的粉丝数&quot;)" class="learn"></el-input>
          </el-form-item>
        </div>
        <el-form-item class="form-item" prop="accountImages" :label="$cms('c_7961979fe6a6', 'f_0011', &quot;你的账号主页&quot;)">
          <file-upload 
            v-model="form.accountImages" 
            :multiple="true" 
            :max="5" 
            accept="image/*"
            @success="onUploadSuccess"
            @error="onUploadError"
          >
            <div class="up-box">{{ $cms('c_7961979fe6a6', 'f_0012', "上传图片") }}</div>
          </file-upload>
        </el-form-item>
        <el-form-item class="form-item" prop="problems" :label="$cms('c_7961979fe6a6', 'f_0013', &quot;你目前面临的问题是什么？简单描述（内容？直播？团队？供应链？）&quot;)">
          <el-input v-model="form.problems" :placeholder="$cms('c_7961979fe6a6', 'f_0014', &quot;请描述面临问题&quot;)" class="learn"></el-input>
        </el-form-item>
        <el-form-item class="form-item" prop="requirements" :label="$cms('c_7961979fe6a6', 'f_0015', &quot;你的合作诉求是什么？&quot;)">
          <el-input v-model="form.requirements" :placeholder="$cms('c_7961979fe6a6', 'f_0016', &quot;请输入你的合作诉求&quot;)" class="learn"></el-input>
        </el-form-item>
        <el-form-item class="form-item" prop="supplements" :label="$cms('c_7961979fe6a6', 'f_0017', &quot;还有什么补充的吗？&quot;)">
          <el-input v-model="form.supplements" :placeholder="$cms('c_7961979fe6a6', 'f_0018', &quot;请输入补充内容&quot;)" class="learn"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div 
      class="submit-btn" 
      :class="{ 'submitting': isSubmitting }"
      @click="submitForm"
    >
      <span v-if="!isSubmitting">{{ $cms('c_7961979fe6a6', 'f_0019', "提交申请") }}</span>
      <span v-else>{{ $cms('c_7961979fe6a6', 'f_0020', "提交中...") }}</span>
    </div>
  </div>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue';

export default {
  name: 'Type1Form',
  components: {
    FileUpload,
  },
  props: {
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        accountId: '',
        fansCount: '',
        accountImages: [], // v-model 绑定的图片列表
        problems: '',
        requirements: '',
        supplements: ''
      },
      rules: {
        accountId: [
          { required: true, message: '请输入账号ID', trigger: 'blur' },
        ],
        fansCount: [
          { required: true, message: '请输入粉丝数', trigger: 'blur' },
        ],
        accountImages: [
          { required: true, message: '请上传账号主页图片', trigger: 'change' },
        ],
        problems: [
          { required: true, message: '请描述面临的问题', trigger: 'blur' },
        ],
        requirements: [
          { required: true, message: '请输入合作诉求', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    onUploadSuccess(url) {
      console.log('图片上传成功:', url);
      console.log('当前图片列表:', this.form.accountImages);
      this.$emit('upload-success', url);
    },

    onUploadError(error) {
      console.error('上传失败:', error);
      this.$message.error('文件上传失败');
      this.$emit('upload-error', error);
    },

    // 提交表单
    submitForm() {
      if (this.isSubmitting) {
        return; // 如果正在提交，直接返回
      }
      
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('表单数据:', this.form);
          this.$emit('submit', this.form);
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    },

    // 获取表单数据
    getFormData() {
      return this.form;
    },

    // 验证表单
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          resolve(valid);
        });
      });
    }
  },
}
</script>

<style lang="less" scoped>
@import "./apply-join.less";
</style>
